__turbopack_context__.v({
  "button": "Button-module-scss-module__0_cfXW__button",
  "danger": "Button-module-scss-module__0_cfXW__danger",
  "ghost": "Button-module-scss-module__0_cfXW__ghost",
  "l": "Button-module-scss-module__0_cfXW__l",
  "m": "Button-module-scss-module__0_cfXW__m",
  "primary": "Button-module-scss-module__0_cfXW__primary",
  "s": "Button-module-scss-module__0_cfXW__s",
  "secondary": "Button-module-scss-module__0_cfXW__secondary",
  "tertiary": "Button-module-scss-module__0_cfXW__tertiary",
});
